import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import {
  SAVE_API_ID,
  SAVE_LOADING_STEP,
  TOGGLE_API_LOADED,
  TOGGLE_API_READY,
  TOGGLE_INSTANCE_READY,
  TOGGLE_LOADING
} from "@/store/mutation-types";

export default {
  actions: {
    checkInstance: async ({ commit }) => {
      return ApiRequest.exploreGet("ready", GetHeaders.dataHeaders()).then(
        res => {
          if (!res) {
            return;
          }
          const ready = res.status;
          commit(TOGGLE_INSTANCE_READY, { instance_ready: res.status === 200 });
          return ready;
        }
      );
    },
    saveApiId: ({ state, commit }, payload) => {
      if (state.apiId !== payload.apiId) {
        commit(TOGGLE_API_LOADED, { api_loaded: false });
        commit(TOGGLE_API_READY, { api_ready: false });
      }
      commit(SAVE_API_ID, {
        apiId: payload.apiId,
        currentProjectName: payload.currentProjectName,
        currentModelName: payload.currentModelName,
        currentDbType: payload.currentDbType,
      });
    },
    loadAPI: async ({ state }) => {
      return ApiRequest.exploreGet(
        "loading?action=load&hu_id=" + state.apiId,
        GetHeaders.dataHeaders()
      );
    },
    checkAPI: async ({ commit }) => {
      return ApiRequest.exploreGet("loadready", GetHeaders.dataHeaders()).then(
        res => {
          commit(TOGGLE_API_LOADED, { api_loaded: res.data.status === "ok" });

          if (res.data.status === "ok") {
            return true;
          }
          if (res.data.status === "failed") {
            return false;
          }

          return null;
        }
      );
    },
    errorLog: async () => {
      return ApiRequest.exploreGet("bugs", GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    ping: async () => {
      return ApiRequest.exploreGet("ping", GetHeaders.dataHeaders());
    },
    loadAnimStart: async ({commit}) => {
      commit(TOGGLE_LOADING, {loading: true});
    },
    loadAnimEnd: async ({commit}) => {
      commit(TOGGLE_LOADING, {loading: false});
    },
    saveLoadingStep: async ({commit}, payload) => {
      commit(SAVE_LOADING_STEP, {loading_step: payload})
    }
  },
  getters: {},
  mutations: {
    [TOGGLE_INSTANCE_READY](state, payload) {
      if (payload) {
        state.instanceReady = payload.instance_ready;
      } else {
        state.instanceReady = !state.instanceReady;
      }
    },
    [SAVE_LOADING_STEP](state, payload) {
      //if(payload && payload.loading_step && payload.loading_step !== "" && payload.loading_step !== "null"){
      //  state.loadingStep += "\n"+payload.loading_step
      //}
      //else{
        state.loadingStep = payload.loading_step;
      //}
    },
    [TOGGLE_LOADING](state, payload) {
      if (payload) {
        state.loading = payload.loading;
      } else {
        state.loading = !state.loading;
      }
    },
    [SAVE_API_ID](state, payload) {
      state.apiId = payload.apiId;
      state.currentProjectName = payload.currentProjectName;
      state.currentModelName = payload.currentModelName;
      localStorage.setItem("apiId", payload.apiId);
      localStorage.setItem('currentModelName', payload.currentModelName);
      localStorage.setItem('currentDbType', payload.currentDbType);
    },
    [TOGGLE_API_READY](state, payload) {
      if (payload) {
        state.apiReady = payload.api_ready;
      } else {
        state.apiReady = !state.apiReady;
      }
    },
    [TOGGLE_API_LOADED](state, payload) {
      if (payload) {
        state.apiLoaded = payload.api_loaded;
      } else {
        state.apiLoaded = !state.apiLoaded;
      }
    }
  },
  state: {
    apiId: null,
    apiLoaded: false,
    apiReady: false,
    currentModelName: null,
    currentProjectName: null,
    instanceReady: false,
    loading: false,
    loadingStep: null
  }
};
